import { Box, Grid, Typography } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useParams } from '@reach/router'
import React, { useEffect, useMemo, useState } from 'react'
import { errorToast } from '../../../../utils/errToast'
import axios from '../../../axios'
import { baseURL, CSEvents, ENDPOINTS } from '../../../constants'
import { tracker } from '../../../systemLogs'
import ConfirmationDialog from '../../confirmationDialog'
import IgImageView from '../../IgImageView'
import NoticeDialog from '../../noticeDialog'
import CHRcard from './card'
import { styles } from './styles'
import { stylesGrid } from './stylesGrid'

// import IOSSwitch from '../../IOSSwitch'
// import BirdAvatar from '../../../assets/images/chirpyest-white.svg'

function array_move(arr: any, old_index: number, new_index: number) {
  const copy = JSON.parse(JSON.stringify(arr))
  copy.splice(new_index, 0, copy.splice(old_index, 1)[0])
  return copy
}

interface FoldersViewProps {
  isFolderView: boolean
  onChange: Function
  shouldShowPublic: boolean
  onChangePublic: Function
  folders: any
  origFolders: any
  allItems: any
  handleRemoveFolder: Function
  canEdit: boolean
  isPositionSort: boolean
  /** Viewer is an admin looking at another member's board — see `privateFolderBadge`. */
  isAdminView?: boolean
}

const FoldersView = (props: FoldersViewProps) => {
  const {
    isFolderView,
    onChange,
    shouldShowPublic,
    onChangePublic,
    folders,
    origFolders,
    allItems,
    handleRemoveFolder,
    canEdit = false,
    isPositionSort,
    isAdminView = false,
  } = props

  const [renderedFolders, setRenderedFolders] = useState(folders)
  const moveNoticeState = useState(false)

  const featuredFolders = useMemo(() => {
    return origFolders.filter((f: any) => f.isFeatured === true)
  }, [origFolders])

  const theme = useTheme()
  const isPhone = useMediaQuery(theme.breakpoints.down('xs'), { noSsr: true })

  useEffect(() => {
    setRenderedFolders(folders)
  }, [folders])

  const moveCard = (dragIndex: number, hoverIndex: number) => {
    if (!isPositionSort) {
      moveNoticeState[1](true)
      return
    }
    setRenderedFolders(array_move(renderedFolders, dragIndex, hoverIndex))
  }

  const handleUpdatePosition = async (
    id: number,
    currentPosition: number,
    newPosition: any
  ) => {
    try {
      const payload = {
        id,
        currentPosition,
        newPosition,
      }
      if (newPosition !== currentPosition) {
        await axios.post(`${baseURL}${ENDPOINTS.swapFolderPosition}`, payload)
        const resp = await axios.get(
          `${baseURL}${ENDPOINTS.sbFolders.replace(':username', userName)}`
        )
        const sortedFolders = resp.data.data.folders.map((folder: any) => {
          const sortedItems = folder.items.sort(
            (a: any, b: any) => a.position - b.position
          )
          return { ...folder, items: sortedItems }
        })
        setRenderedFolders(sortedFolders)
      }
    } catch (err) {
      errorToast(`couldn't update position, please try again`)
    }
  }

  const classesGrid = stylesGrid()
  const classes = styles()
  const { userName } = useParams()
  const [open, setOpen] = useState(false)
  const [selectedFolder, setSelectedFolder] = useState({
    name: null,
    folderId: null,
  })

  const onRemove = (e: any, folder: any) => {
    e.stopPropagation()
    setOpen(true)
    setSelectedFolder({ ...folder })
  }

  return (
    <div>
      {featuredFolders.length > 0 ? (
        <Box>
          <Typography variant="h4" className={classes.edgeSpaces}>
            featured
          </Typography>

          <div className={classesGrid.wrapper}>
            <Grid container spacing={isPhone ? 2 : 3}>
              {featuredFolders.map((elGrid: any, i: any) => {
                return (
                  <CHRcard
                    key={elGrid.folderId}
                    index={i}
                    id={elGrid.folderId}
                    folder={{ ...elGrid, name: elGrid.name.toLowerCase() }}
                    canEdit={false}
                    isAdminView={isAdminView}
                    userName={userName}
                    onClick={() => {
                      tracker.trackCs(CSEvents.viewBoard, {
                        pageUrl: window.location.href,
                        shoppingBoardFolder: {
                          id: elGrid.folderId,
                          name: elGrid.name,
                        },
                        shoppingBoardFolderName: elGrid.folderId,
                        shoppingBoardUsername: userName,
                        section: 'sb-folder-view-featured',
                      })
                    }}
                  />
                )
              })}
            </Grid>
          </div>
        </Box>
      ) : null}

      <Typography
        variant="h4"
        className={classes.edgeSpaces}
        style={{ marginTop: 15 }}
      >
        all folders
      </Typography>

      <div className={classesGrid.wrapper}>
        <Grid container spacing={isPhone ? 2 : 3}>
          {allItems && allItems.length > 0 && (
            <Grid
              item
              lg={3}
              md={4}
              sm={4}
              xs={12}
              className={classes.gridItem}
              onClick={() => {
                tracker.trackCs(CSEvents.viewBoard, {
                  pageUrl: window.location.href,
                  shoppingBoardUsername: userName,
                  section: 'sb-folder-view-all-items',
                })
                onChange(false)
                history.pushState('', document.title, window.location.pathname)
              }}
            >
              <div>
                {allItems.map(
                  ({ type, data: { url, link, imageUrl, base64 } }) =>
                    type === 'instagram' ? (
                      <IgImageView
                        url={url || link}
                        className={classes.image}
                      />
                    ) : (
                      <img
                        src={imageUrl || base64}
                        alt=""
                        className={classes.image}
                      />
                    )
                )}
              </div>
              <Typography
                variant="h2"
                className={`${classes.edgeSpaces} ${classes.folderName}`}
              >
                all items
              </Typography>
            </Grid>
          )}
          {renderedFolders.map((elGrid: any, i: any) => {
            return (
              <CHRcard
                key={elGrid.folderId}
                index={i}
                id={elGrid.folderId}
                moveCard={moveCard}
                folder={{ ...elGrid, name: elGrid.name.toLowerCase() }}
                handleUpdatePosition={handleUpdatePosition}
                canEdit={canEdit}
                isAdminView={isAdminView}
                onRemove={onRemove}
                userName={userName}
                onClick={() => {
                  tracker.trackCs(CSEvents.viewBoard, {
                    pageUrl: window.location.href,
                    shoppingBoardUsername: userName,
                    shoppingBoardFolder: {
                      id: elGrid.folderId,
                      name: elGrid.name,
                    },
                    section: 'sb-folder-view-listing',
                  })
                }}
              />
            )
          })}
        </Grid>
      </div>

      <NoticeDialog attachState={moveNoticeState}>
        <Box>
          in order to move an item on board, go to the "sort by" menu and change
          it to "custom position"
        </Box>
      </NoticeDialog>

      <ConfirmationDialog
        attachState={[open, setOpen]}
        title="delete folder"
        onConfirm={() => handleRemoveFolder(selectedFolder.folderId)}
      >
        <Box>
          are you sure you want to delete{' '}
          <strong>"{selectedFolder.name}"</strong> folder?
        </Box>
      </ConfirmationDialog>
    </div>
  )
}

export default FoldersView
